var elem = document.querySelector(".carousel.product__image-slider");
// var multiple_images = elem.children;

if (elem) {
  // debugger;d
  var flkty;
  flkty = new Flickity(elem, {
    contain: true,
    imagesLoaded: true,
    lazyLoad: 1,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: elem.children || false,
    pageDots: elem.dataset.dots == "true" || false,
    cellAlign: "left",
    freeScroll: false,
    on: {
      ready: function (e) {
        console.log("Flickity ready", e);
        var element = document.querySelector(".carousel.product__image-slider");
        var product_media = Flickity.data(element);
        product_media.resize();
      },
    },
    // adaptiveHeight: true,
  });
}

var elemThumbnail = document.querySelector(
  ".carousel.product__image-thumbnail",
);
if (elemThumbnail) {
  var flktyB = new Flickity(elemThumbnail, {
    asNavFor: ".carousel.product__image-slider",
    contain: true,
    imagesLoaded: true,
    lazyLoad: 4,
    pageDots: false,
    prevNextButtons: false,
  });
}
